import { render, staticRenderFns } from "./ComercioTable.vue?vue&type=template&id=a9c60656&scoped=true&lang=pug&"
import script from "./ComercioTable.vue?vue&type=script&lang=js&"
export * from "./ComercioTable.vue?vue&type=script&lang=js&"
import style0 from "./ComercioTable.vue?vue&type=style&index=0&id=a9c60656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c60656",
  null
  
)

export default component.exports